// import React, { useState, useEffect } from "react";
// import { useHistory } from 'react-router-dom';
// import { connect } from "react-redux";
// import axios from "axios";
// import { NavLink } from "react-bootstrap";
// import ConfirmDeleteModal from './ConfirmationModelDelete';
// import { saveAs } from 'file-saver';
// import { Parser } from 'json2csv';

// const JobsList = () => {
//   const [categories, setCategories] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [pincodeQuery, setPincodeQuery] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const history = useHistory();
//   const token = localStorage.getItem('authToken');
  
//   const getData = async () => {
//     try {
//       const response = await axios.get(`https://samaj.aasmo.in/api/admin/jobs?page=${currentPage}&search=${searchQuery}&pincode=${pincodeQuery}`, {
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         },
//       });
//       setCategories(response.data.jobs);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleEdit = (id) => {
//     history.push(`/editjobs/${id}`);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`https://samaj.aasmo.in/api/admin/jobs/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         },
//       });
//       if (response) {
//         console.log("Deleted Successfully");
//         getData();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setShowModal(false);
//   };

//   const handleDeleteClick = (id) => {
//     setSelectedCategoryId(id);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     getData();
//   }, [currentPage, searchQuery, pincodeQuery]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handlePincodeSearch = (e) => {
//     setPincodeQuery(e.target.value);
//   };

//   const handleDownload = () => {
//     const fields = [
//       "id", "title", "image", "salary", "description", "createdAt", "companyName", "address", "pincode"
//     ];
//     const json2csvParser = new Parser({ fields });
//     const csv = json2csvParser.parse(categories);
//     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//     saveAs(blob, 'jobs_list.csv');
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };
//   const formatDescription = (description) => {
//     return description.length > 10 ? description.slice(0, 10) + '...' : description;
//   };
//   return (
//     <div className="col-lg-12">
//       <div className="card">
//         <div className="header">
//           <h2>Job List</h2>
//         </div>
//         <div className="d-flex justify-content-start">
//           {/* <div className="input-group m-b-10 col-lg-3">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Title"
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </div> */}
//           <div className="input-group m-b-10 col-lg-3">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Pincode"
//               value={pincodeQuery}
//               onChange={handlePincodeSearch}
//             />
//           </div>
//           <div>
//             <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
//           </div>
//         </div>
//         <div className="body table-responsive">
//           <table className="table table-hover">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Category</th>
//                 <th>Title</th>
//                 <th>Image</th>
//                 <th>Salary</th>
//                 <th>Description</th>
//                 <th>Company Name</th>
//                 <th>Address</th>
//                 <th>Pincode</th>
//                 <th>Status</th>
//                 <th>Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {categories.map((category, index) => {
//                 let statusClass;
//                 switch (category.status) {
//                   case 'rejected':
//                     statusClass = 'text-danger';
//                     break;
//                   case 'yes':
//                   case 'approved':
//                     statusClass = 'text-success';
//                     break;
//                   default:
//                     statusClass = 'text-primary';
//                 }
//                 const imageUrl = `https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`;
//                 return (
//                   <tr key={category.id}>
//                     <td>{(currentPage - 1) * 10 + index + 1}</td>
//                     <td>{category.category.name}</td>
//                     <td>{category.title}</td>
//                     <td>
//                       <img src={imageUrl} width={50} height={50} className="rounded-circle user-photo" alt="Category" />
//                     </td>
//                     <td>{category.salary}</td>
//                     <td>{formatDescription(category.description)}</td>
//                     <td>{category.companyName}</td>
//                     <td>{formatDescription(category.address)}</td>
//                     <td>{category.pincode}</td>
//                     <td className={statusClass}>
//                       {category.status === 'rejected' ? 'Rejected' : category.status === 'yes' || category.status === 'approved' ? 'Approved' : 'Pending'}
//                     </td>
//                     <td>{formatDate(category.createdAt)}</td>
//                     <td>
//                       <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
//                       &nbsp;&nbsp;
//                       <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//         <div className="body">
//           <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
//             <ul className="pagination">
//               <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage - 1)}
//                 >
//                   Previous
//                 </NavLink>
//               </li>
//               {[...Array(totalPages).keys()].map(page => (
//                 <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
//                   <NavLink
//                     to="#"
//                     className="page-link"
//                     onClick={() => handlePageChange(page + 1)}
//                   >
//                     {page + 1}
//                   </NavLink>
//                 </li>
//               ))}
//               <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage + 1)}
//                 >
//                   Next
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//       <ConfirmDeleteModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         handleConfirm={() => handleDelete(selectedCategoryId)}
//       />
//     </div>
//   );
// };

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default connect(mapStateToProps, {})(JobsList);


import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const JobsList = () => {
  const [categories, setCategories] = useState([]); // Renamed to 'jobs' for clarity, but keeping 'categories' for now to match original code structure
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [pincodeQuery, setPincodeQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); // Renamed to 'selectedJobId' for clarity
  const history = useHistory();
  const token = localStorage.getItem('authToken');
  
  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/jobs?page=${currentPage}&search=${searchQuery}&pincode=${pincodeQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      setCategories(response.data.jobs); // Still using setCategories to update the state variable
      setTotalPages(response.data.totalPages);
      // IMPORTANT: Log the data to inspect the 'image' property
      console.log("Fetched jobs data:", response.data.jobs); 
    } catch (error) {
      console.error("Error fetching jobs:", error); // Use console.error for better visibility of errors
    }
  };

  const handleEdit = (id) => {
    history.push(`/editjobs/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/jobs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response.status === 200) { // Check for a successful status code
        console.log("Job Deleted Successfully");
        getData(); // Refresh data after successful deletion
      } else {
        console.warn("Delete request did not return success status:", response);
      }
    } catch (error) {
      console.error("Error deleting job:", error); // Use console.error
    } finally {
      setShowModal(false); // Close modal regardless of success or failure
    }
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id); // Using the original state variable name
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery, pincodeQuery, token]); // Added 'token' to dependencies

  const handlePageChange = (page) => {
    // Ensure the page number is valid before setting
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const handlePincodeSearch = (e) => {
    setPincodeQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const handleDownload = () => {
    const fields = [
      "id", "title", "image", "salary", "description", "createdAt", "companyName", "address", "pincode"
      // Add 'category.name' if you want category name in CSV.
      // Note: json2csv might need a custom accessor for nested fields like 'category.name' if not flattening.
      // For simplicity, sticking to top-level fields or simple nested ones if they are directly extracted by json2csv.
    ];
    try {
      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(categories); // Using 'categories' state for jobs data
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'jobs_list.csv');
    } catch (err) {
      console.error('Error generating CSV:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString might be null/undefined
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const formatDescription = (description) => {
    if (!description) return ''; // Handle cases where description might be null/undefined
    return description.length > 50 ? description.slice(0, 50) + '...' : description; // Increased slice length for better readability
  };
  const formatAddress = (address) => {
    if (!address) return '';
    return address.length > 50 ? address.slice(0, 50) + '...' : address;
  }

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Job List</h2>
        </div>
        <div className="d-flex justify-content-start flex-wrap align-items-center"> {/* Added flex-wrap and align-items-center */}
          <div className="input-group m-b-10 col-lg-3 col-md-6 col-sm-12"> {/* Added responsive classes */}
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Pincode"
              value={pincodeQuery}
              onChange={handlePincodeSearch}
            />
          </div>
          {/* Re-enabled Search By Title, if desired, with similar styling */}
          <div className="input-group m-b-10 col-lg-3 col-md-6 col-sm-12">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Title"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div className="m-b-10 ml-auto mr-3"> {/* Moved download button to the right */}
            <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Category</th>
                <th>Title</th>
                <th>Image</th>
                <th>Salary</th>
                <th>Description</th>
                <th>Company Name</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((job, index) => { // Renamed 'category' to 'job' for clarity when mapping jobs
                  let statusClass;
                  switch (job.status) {
                    case 'rejected':
                      statusClass = 'text-danger';
                      break;
                    case 'yes':
                    case 'approved':
                      statusClass = 'text-success';
                      break;
                    default:
                      statusClass = 'text-primary'; // For 'pending' or other unknown statuses
                  }

                  // Determine image source based on whether it's a full URL or a relative path
                  let finalImageUrl;
                  if (job.image) {
                      // Simple check: if it starts with 'http', assume it's a full URL
                      if (job.image.startsWith('http://') || job.image.startsWith('https://')) {
                          finalImageUrl = job.image;
                      } else {
                          // Otherwise, prepend the S3 base URL
                          finalImageUrl = `https://uma-classees.blr1.digitaloceanspaces.com/${job.image}`;
                      }
                  }
                  
                  return (
                    <tr key={job.id}>
                      <td>{(currentPage - 1) * 10 + index + 1}</td>
                      <td>{job.category ? job.category.name : 'N/A'}</td> {/* Added check for category existence */}
                      <td>{job.title}</td>
                      <td>
                        {/* Image display with robust fallback and error handling */}
                        {finalImageUrl ? (
                          <img 
                            src={finalImageUrl} 
                            width={50} 
                            height={50} 
                            className="rounded-circle user-photo" 
                            alt={job.title || "Job Image"} 
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop if placeholder also fails
                              e.target.src = 'https://via.placeholder.com/50?text=Error'; // Generic placeholder on error
                              console.warn(`Failed to load image for job "${job.title}". URL: ${finalImageUrl}`);
                            }}
                          />
                        ) : (
                          // Placeholder if image path is not provided by API
                          <img 
                            src="https://via.placeholder.com/50?text=No+Image" 
                            width={50} 
                            height={50} 
                            className="rounded-circle user-photo" 
                            alt="No Image Available" 
                          />
                        )}
                      </td>
                      <td>{job.salary}</td>
                      <td>{formatDescription(job.description)}</td>
                      <td>{job.companyName}</td>
                      <td>{formatAddress(job.address)}</td> {/* Using formatAddress */}
                      <td>{job.pincode}</td>
                      <td className={statusClass}>
                        {job.status === 'rejected' ? 'Rejected' : job.status === 'yes' || job.status === 'approved' ? 'Approved' : 'Pending'}
                      </td>
                      <td>{formatDate(job.createdAt)}</td>
                      <td>
                        <i className="icon-pencil" onClick={() => handleEdit(job.id)} style={{ cursor: 'pointer' }}></i>
                          
                        <i className="fa fa-trash-o" onClick={() => handleDeleteClick(job.id)} style={{ cursor: 'pointer' }}></i>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12" className="text-center">No jobs found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(JobsList);